import { OfferingType } from '../../../../graphql';
import { useCheckPrivatePlacementTrait } from './useCheckPrivatePlacementTrait';

export const useGetTraitExcludedOfferingTypes = (): OfferingType[] => {
  const hasPrivatePlacementTrait = useCheckPrivatePlacementTrait();

  return hasPrivatePlacementTrait
    ? Object.values(OfferingType).filter(type => type !== OfferingType.PrivatePlacement)
    : [OfferingType.PrivatePlacement];
};
